import { ContentItem } from '@kentico/kontent-delivery';
import get from 'lodash/get';
import { ICheckboxProps } from '../components/form/components/checkbox/checkbox';

export class CheckboxModel extends ContentItem {
  get name(): string {
    return get(this._config, 'elements.name.value', '');
  }

  get label(): string {
    return get(this._config, 'elements.label.value', '');
  }

  get image(): string {
    return get(this._config, 'elements.image.value[0].url', '');
  }

  get tooltipText(): string {
    return get(this._config, 'elements.tooltip_text.value', '');
  }

  get value(): string {
    return get(this._config, 'elements.value.value', '');
  }

  get required(): boolean {
    return get(this._config, 'elements.required.value[0].codename') === 'true';
  }

  get displayOnInput(): boolean {
    return (
      get(this._config, 'elements.display_on_input.value[0].codename') ===
      'true'
    );
  }

  get smallText(): boolean {
    return (
      get(this._config, 'elements.small_text.value[0].codename') === 'true'
    );
  }

  public static create(data: ICheckbox): ICheckboxProps {
    const {
      label,
      image,
      tooltipText,
      required,
      name,
      displayOnInput,
      smallText,
      value
    } = new CheckboxModel(data);
    return {
      label,
      image,
      tooltipText,
      required,
      name,
      displayOnInput,
      smallText,
      value
    };
  }
}
